export function getApiBase(): string {
  return (import.meta.env.VITE_BACKEND_URL ?? 'https://places-in-time-history-chat.onrender.com').replace(/\/$/, '')
}

export function resolveMediaUrl(mediaPath: string | null | undefined): string | null
export function resolveMediaUrl(apiBase: string, mediaPath: string | null | undefined): string | null
export function resolveMediaUrl(arg1: string | null | undefined, arg2?: string | null | undefined): string | null {
  const hasExplicitBase = typeof arg2 !== 'undefined'
  const apiBase = hasExplicitBase ? (arg1 ?? '').toString().replace(/\/$/, '') : getApiBase()
  const mediaPath = hasExplicitBase ? arg2 : arg1

  if (!mediaPath) return null

  const trimmed = mediaPath.trim()
  if (!trimmed) return null

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed
  }

  if (trimmed.startsWith('/')) {
    return trimmed
  }

  if (!apiBase) return null

  const normalized = trimmed.replace(/^\/+/, '')
  return `${apiBase}/media/${normalized}`
}

export const getMediaUrl = (mediaPath?: string | null) => resolveMediaUrl(getApiBase(), mediaPath ?? null)
